export default function(): void {
    // Link to bootstrap tab (desktop) or accordion (mobile)
    const linkToTab = (navLink: string | null) => {
        if (window.innerWidth > 767) {
            var tabElement = document.querySelector(
                `.nav-tabs a[href="${navLink}"]`
            ) as HTMLElement;

            if (tabElement) {
                tabElement.click();
                tabElement.focus();
                tabElement.scrollIntoView();
            }
        } else {
            var tabElement = document.querySelector(
                `.accordion [data-nav-href='${navLink}']`
            ) as HTMLElement;

            if (tabElement && tabElement.getAttribute('aria-expanded') === 'true') {
                tabElement.focus();
                tabElement.scrollIntoView();
            } else if (tabElement) {
                tabElement.click();
                setTimeout(() => {
                    tabElement.focus();
                    tabElement.scrollIntoView();
                }, 300);
            }
        }
    };

    // On page load event listener
    window.addEventListener('load', () => {
        const hash = location.hash.replace(/^#/, '#');
        hash !== '' ? linkToTab(hash) : null;
    });

    // On click event listeners for all links with a data-nav-link attribute
    window.addEventListener('load', () => {
        const navLinks = document.querySelectorAll('[data-nav-link]');
        navLinks.forEach(link => {
            link.addEventListener('click', e => {
                e.preventDefault();
                linkToTab(link.getAttribute('data-nav-link'));
            });
        });
    });
}
